export default __webpack_public_path__ + "static/media/83.5b82f663.svg";